import { useReducer } from "react";

export const initial: State = {
	themeMode: "light"
};

export interface State {
	themeMode: "light" | "dark";
}

enum ActionType {
	onChangeThemeMode = "onChangeThemeMode"
}

interface Action {
	type: string;
	val: "light" | "dark";
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.onChangeThemeMode:
			return {
				...state,
				themeMode: action.val
			};

		default:
			throw new Error("action type not found");
	}
}

export default function useThemeStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		onChangeThemeMode: (val: "light" | "dark") =>
			dispatch({ type: ActionType.onChangeThemeMode, val })
	};

	return [state, actions] as const;
}
